import * as PIXI from 'pixi.js';
import { vec2 } from "@tlaukkan/tsm";
import { Resolution } from "../../../shared/constants";
import defaultVert from "./shaders/vertex/default";
import { createQuadMesh } from './spriteFactory';
import { RenderEngine } from './renderEngine';
import { BackgroundLayer } from './backgroundLayer';
import cilia from './shaders/fragment/cilia';
import { Colors } from '../palettes/colorPalette';


export class CiliaLayer implements BackgroundLayer {
	mesh: PIXI.Mesh;
	sprites = new PIXI.Container();
	private cilia = new PIXI.Program(defaultVert, cilia);
	private renderTexture: PIXI.RenderTexture

	constructor(private engine: RenderEngine, private sceneRoot: PIXI.Container, private renderer: PIXI.Renderer) {
		this.renderTexture = PIXI.RenderTexture.create({ width: Resolution.Width, height: Resolution.Height });

		//Create the background
		this.mesh = createQuadMesh(Resolution.Width, Resolution.Height, this.cilia, {
			time: 0,
			texture: this.renderTexture,
			texelSize: [1 / Resolution.Width, 1 / Resolution.Height],
			cameraPosition: [0, 0],
			cameraScale: 1,
			lightPos: this.engine.lightSource.xy,
		});
		this.mesh.blendMode = PIXI.BLEND_MODES.NORMAL_NPM;
	}

	update(delta: number, time: number) {
		//Match size of the parent container
		this.sprites.position.set(this.engine.membraneRoot.x, this.engine.membraneRoot.y);
		this.sprites.scale.set(this.engine.membraneRoot.scale.x, this.engine.membraneRoot.scale.y);
		this.mesh.position.set(-this.engine.membraneRoot.x * (1 / this.engine.membraneRoot.scale.x), -this.engine.membraneRoot.y * (1 / this.engine.membraneRoot.scale.y));
		this.mesh.scale.set(1 / this.engine.membraneRoot.scale.x, 1 / this.engine.membraneRoot.scale.y);

		this.mesh.shader.uniforms.time += delta;
		this.mesh.shader.uniforms.cameraPosition = [
			this.sceneRoot.x / (Resolution.Width * this.sceneRoot.scale.x),
			this.sceneRoot.y / (Resolution.Height * this.sceneRoot.scale.y)
		];
		this.mesh.shader.uniforms.cameraScale = this.sceneRoot.scale.x;
		this.renderer.render(this.sprites, this.renderTexture);
	}

	addSprite(sprite: PIXI.Sprite) {
		this.sprites.addChild(sprite);
	}
}